import { Button, DatePicker } from 'antd'
import dayjs from 'dayjs'

import { classNames } from '@/Ship/Helpers/classNames'

import { ALL_TIME, REPORT_DAY_FORMAT, REPORT_DISPLAY_FORMAT, reportPeriodPresets, samePeriod } from '../Helpers/reportPeriod'

import type { IReportPeriod } from '../Contracts/IReportPeriod'

import styles from './Report.module.css'

const { RangePicker } = DatePicker

export interface ReportPeriodFilterProps {
    period: IReportPeriod
    onChange: (period: IReportPeriod) => void
}

/**
 * Фільтр періоду (`SPEC-027` §3.4, К-04): поле «з — по» у форматі ДД.ММ.РРРР
 * і пресети «Цей місяць», «Минулий місяць», «Цей рік», «Увесь час».
 *
 * «Увесь час» — кнопкою поруч, а не пресетом усередині календаря: пресет
 * antd — це пара дат, а «весь час» — відсутність меж. Очищення поля — той
 * самий «Увесь час».
 */
export const ReportPeriodFilter = ({ period, onChange }: ReportPeriodFilterProps) => {
    const value: [dayjs.Dayjs, dayjs.Dayjs] | null =
        period.from !== null && period.to !== null
            ? [dayjs(period.from, REPORT_DAY_FORMAT), dayjs(period.to, REPORT_DAY_FORMAT)]
            : null

    return (
        <div className={classNames(styles['filter'])} data-testid="report-period-filter">
            <span className={classNames(styles['filterLabel'])}>Період</span>
            <RangePicker
                value={value}
                format={REPORT_DISPLAY_FORMAT}
                allowClear
                placeholder={['Початок', 'Кінець']}
                aria-label="Період звіту"
                onChange={(range) => {
                    const [start, end] = range ?? []

                    onChange(
                        start && end
                            ? { from: start.format(REPORT_DAY_FORMAT), to: end.format(REPORT_DAY_FORMAT) }
                            : ALL_TIME
                    )
                }}
            />
            <div className={classNames(styles['presets'])}>
                {reportPeriodPresets().map((preset) => (
                    <Button
                        key={preset.label}
                        size="small"
                        type={samePeriod(preset.period, period) ? 'primary' : 'default'}
                        onClick={() => onChange(preset.period)}
                    >
                        {preset.label}
                    </Button>
                ))}
            </div>
        </div>
    )
}
